export default __webpack_public_path__ + "595bdc7f1a1efef01fc9145b7a1ef0bd.woff";